<template>
	
	<div class="c-panel c-panel--small text-center">

		<svg class="color-primary margin-t-40 margin-b-24" width="96" height="96" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="evenodd"><path d="M12 22a9.9964 9.9964 0 0 1-7.0704-2.9296 9.9964 9.9964 0 0 1 0-14.1408 9.9964 9.9964 0 0 1 14.1408 0 9.9964 9.9964 0 0 1 0 14.1408A9.9962 9.9962 0 0 1 12 22Zm0-17.9994a8.0003 8.0003 0 0 0-5.6566 2.3427 8.0002 8.0002 0 0 0 0 11.3132 8.0002 8.0002 0 0 0 11.3132 0 8.0002 8.0002 0 0 0 0-11.3132A8.0002 8.0002 0 0 0 12 4.0006Z"/><path d="M10.6158 15.5294a1.0078 1.0078 0 0 1-.7095-.2984l-2.9094-2.8948a.9905.9905 0 0 1 0-1.4026 1.002 1.002 0 0 1 .7095-.2947c.2672 0 .5221.1063.7105.2947l2.1998 2.1888 4.3791-4.3571-.001-.001a1.0033 1.0033 0 0 1 .7105-.2937c.2662 0 .5221.1054.7095.2938a.9905.9905 0 0 1 0 1.4026l-5.0885 5.063v.001a1.01 1.01 0 0 1-.7105.2984Z"/></g></svg>

		<h3 class="margin-b-16">Gelukt! Je wachwoord is aangepast</h3>

		<p>Binnen enkele seconden word je doorgestuurd naar het inlogscherm</p>

		<router-link :to="{name:'login'}" class="c-btn c-btn--primary c-btn--expanded">Naar inloggen</router-link>

	</div>

</template>

<script>
export default {
	data() {
		return {
			timeout: null
		}
	},
	mounted() {
		this.timeout = setTimeout( () => {
			this.$router.push({path: '/inloggen'});
		}, 4000);
	}
}
</script>
